import { Icon } from "@vds/icons";
import React, { useState, useRef, useEffect } from "react";
import {
  Player,
  ControlBar,
  PlaybackRateMenuButton,
  BigPlayButton,
  FullscreenToggle,
} from "video-react";
import "video-react/dist/video-react.css";
import { togglePlayPause } from "../../utility/Utils";

const DashboardVideoPlay = ({
  evidenceUrl,
  isAccordionExpanded
}) => {
  const [playing, setPlaying] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);
  const [image, setImage] = useState(null);
  const playerRef = useRef(null);
  const currentTimeRef = useRef({
    seekTime: 0,
    duration: 0
  });
  const handleStateChange = (state) => {
    setPlaying(!state.paused);
  };
  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      player?.subscribeToStateChange(handleStateChange);
    }
  }, []);

  const handleTogglePlayPause = () => {
    togglePlayPause(playing, playerRef, currentTimeRef, videoUrl);
  };

  useEffect(() => {
    const player = playerRef.current;
    if (!player) return;

    const playerState = player?.getState()?.player;
    const seekTime = currentTimeRef.current?.seekTime || 0;

    let timerId = null;
    if (isAccordionExpanded) {
      // Always resume stream and reload so handleVideoRequest() is triggered on every expand
      player?.load();
      timerId = setTimeout(() => {
        if (seekTime > 0) {
          player?.seek(seekTime);
        }
        player?.play();
      }, 100);
    } else {
      if (playerState?.hasStarted) {
        player?.pause();
        currentTimeRef.current.seekTime = playerState.ended ? 0 : playerState.currentTime;
      }
    }
    return () => {
      clearTimeout(timerId);
      try {
        if (isAccordionExpanded && playerRef.current) {
          playerRef.current.pause();
        }
      } catch (error) {
        console.error("Error pausing player during cleanup:", error);
      }
    };
  }, [isAccordionExpanded])


  useEffect(() => {
    if (evidenceUrl) {
      setVideoUrl(evidenceUrl);
    } else {
      setVideoUrl("");
    }
  }, [evidenceUrl]);


  return (
    <div className="dashboardvideo-player-container"  style={{ display:"flex"}}>
        <Player
          ref={playerRef}
          poster={image}
          src={videoUrl}
          fluid={true}
          autoPlay={false}
          playsInline
          preload="none"
          muted={true}
        >
          <BigPlayButton disabled />
          <div
            className={`overlay ${playing ? "hidden" : ""}`}
            onClick={handleTogglePlayPause}
          >
            {evidenceUrl ? (
              <Icon
                name={playing ? "pause" : "play"}
                size="50px"
                color="#FFFFFF"
              />
            ) : (
              <div style={{ cursor: "not-allowed" }}>
                <Icon name="no-video" size="50px" color="#FFFFFF" />
              </div>
            )}
          </div>
          <ControlBar autoHide>
            <PlaybackRateMenuButton
              rates={[0.25, 0.75, 0.5, 1, 1.5, 2]}
              order={7.1}
            />
            <FullscreenToggle />
          </ControlBar>
        </Player>
    </div>
  );
};

export default DashboardVideoPlay;
